import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';
import MessagesPaneHeader from '../../components/MessagesPaneHeader';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/AriStore';
import FileTreeManager from '../../file-tree-manager/file-tree-manager';
import { Box, Paper } from '@mui/material';

export default function FileTreePage() {
  const menuInfo = useSelector((state: RootState) => state.menu);
  return (
    <>
      <Sidebar />
      <Header />
      <Box component="main" className="MainContent" sx={{ flex: 1 }}>
        <Paper
          sx={{
            height: { xs: '100dvh', lg: '100dvh' },
            display: 'flex',
            flexDirection: 'column',
            pt: { xs: 'var(--Header-height)', sm: 0 },
          }}
        >
          <MessagesPaneHeader menuTitle={menuInfo.selectedName} />
          <Box sx={{ flex: 1, overflow: 'auto' }}>
            <FileTreeManager />
          </Box>
        </Paper>
      </Box>
    </>
  )
}


